module.exports = __webpack_public_path__ + "img/HQ-PA050W2T2RL_ALL.58c938e4.jpg";